import React, { Fragment } from 'react';
import { Motivation, DonationDetails } from './../../elements/DonateElements';
import Sponsor from '../shared/Sponsor';

const DonateDetails = () => (
    <Fragment>
        <Motivation>
            <div className="container">
                <div className="motivate">
                    <h2>What Do We Need From <span className="effect">You?</span></h2>
                    <p>
                        I need your help to sustain the amicable projects that I have
                        envisioned. I have chosen to work my strengths and organise a
                        beauty pageants for young ladies who wish to contribute
                        positively to our society and bring about change in
                        communities they reside in.
                    </p>
                    <p>
                        Not only will your company make my dream come true and
                        help meet a need in an area that is underdeveloped and
                        underutilised but will also fulfil dreams of young people who
                        wish to bring about great change in their communities which
                        will show that your company believes in community
                        development.
                    </p>  
                </div>
            </div>
        </Motivation>

        <DonationDetails>
            <div className="container">
                <div className="donations">
                    <div className="donation">
                        <img src="eft.png" alt="Electronic Payments" />
                        <h2>EFT</h2>
                        <p><strong>Bank Name</strong> - Capitec Bank</p>
                        <p><strong>Account Number</strong> - 1645828717</p>
                        <p><strong>Account Holder</strong> - Za Power House</p>
                    </div>
                </div>
            </div>
        </DonationDetails>
        <Sponsor />
    </Fragment>
)

export default DonateDetails;